// extracted by mini-css-extract-plugin
export default {"confirmModal":"ConfirmModal_confirmModal__glJdc"};